import { TriggeredByDateMessageComponent } from '~/components/elements/TriggeredByDateMessageComponent';
import {
  MedicalInstitutionDataFieldSpecialHolidays,
  MessageFromUbieAimonStyle,
} from '~/components/features/medical-institution/MessageFromUbieAimon/MedicalInstitutionDataFieldSpecialHolidays';

type Props = {
  style: MessageFromUbieAimonStyle;
};

// 時限式の特殊なメッセージを医療機関情報に掲出するコンポーネント
// https://drubie.slack.com/archives/CBV79J338/p1680845156056839
export const MessageFromUbieAimon: React.FC<Props> = ({ style }) => {
  const now = new Date(new Date().toLocaleString('ja-JP', { timeZone: 'Asia/Tokyo' }));
  return (
    <>
      <TriggeredByDateMessageComponent now={now} startDate={new Date('2025-04-28')} endDate={new Date('2025-05-06')}>
        <MedicalInstitutionDataFieldSpecialHolidays
          style={style}
          label="連休期間中の診療時間は、直接医療機関へお問合せください"
        />
      </TriggeredByDateMessageComponent>
      <TriggeredByDateMessageComponent now={now} startDate={new Date('2025-08-09')} endDate={new Date('2025-08-18')}>
        <MedicalInstitutionDataFieldSpecialHolidays
          style={style}
          label="お盆期間中の診療時間は、直接医療機関へお問合せください"
        />
      </TriggeredByDateMessageComponent>
      <TriggeredByDateMessageComponent
        now={now}
        startDate={new Date('2025-12-18T00:00:00+0900')}
        endDate={new Date('2026-01-14T00:00:00+0900')}
      >
        <MedicalInstitutionDataFieldSpecialHolidays
          style={style}
          label="年末年始の診療時間は、直接医療機関へお問合せください"
        />
      </TriggeredByDateMessageComponent>
    </>
  );
};
